module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAABABAMAAACJoGidAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAnUExURUxpcf///////////////////////////////////////////////9z4L/oAAAAMdFJOUwAg33+AEM+hkF9AjzbPFX8AAABySURBVDjLY2AYPIC5AE3A5jiagjNnUJXYnDmDqqTmDJqSMKDAaWQB1hygiAG6ksP0UCKEroRRZ0CVnMRQsgBdSQM+AbAWATyGghU4oCk4Ql8FrOgKwtAV5NBEwQm8ydIHPeGyoCdtBh+0xM/AUsAw+AAAd0iJa/MhedgAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images_member/per1 (54).png
// module id = m14e
// module chunks = 1